export const shiftsWrapperId = 'roster-shifts-wrapper';

export const dropdownId = (shiftId: string) => `shift-dropdown-${shiftId}`;

export interface DropdownSettings {
  bottom?: number;
  top?: number;
  left: number;
  height: number;
}

const MAX_HEIGHT = 300; //px

export const getDropdownSettings = (shiftId: string, options: any[]): DropdownSettings => {
    const wrapperBoundaries = document.querySelector(`#${shiftsWrapperId}`)?.getBoundingClientRect();
    const optionsBoundaries = document.querySelector(`#${dropdownId(shiftId)}`)?.getBoundingClientRect();
    const wrapperBoundariesBottom = wrapperBoundaries?.bottom;
    const optionsStartingPoint = optionsBoundaries?.bottom;

    const minOptionsHeight = 88; // px
    const singleOptionHeight = 32;
    const offset = 10;

    const optionsHeight = Math.min(singleOptionHeight * options.length + offset, MAX_HEIGHT);
    const totalDropdownHeight = minOptionsHeight + optionsHeight;

    const result: DropdownSettings = {
      height: optionsHeight,
      left: optionsBoundaries?.left || 0
    };

    if (wrapperBoundariesBottom && optionsStartingPoint) {
      const topDiff = optionsBoundaries.top - wrapperBoundaries.top;
      const bottomDiff = wrapperBoundaries.bottom - optionsStartingPoint;
      const maxPossibleHeight = Math.max(topDiff, bottomDiff);
      const acceptableHeight = Math.min(totalDropdownHeight, maxPossibleHeight);

      result.height = Math.floor(acceptableHeight);

      if (wrapperBoundariesBottom < optionsStartingPoint + acceptableHeight) {
        result.top = optionsBoundaries.top - result.height;
      } else {
        result.top = optionsBoundaries.bottom;
      }
    }

    return result;
  };